module.exports = __webpack_public_path__ + "media/images/smart_phone/chara_mie-458ff460efd205b3a83fb227748548b8.png";